import { HStack } from '@cad-arc';
import { observer } from 'mobx-react-lite';
import { NotificationCounter } from '../../common/components/notification-counter';
import { getUniversalSearchLabel } from '../../common/helpers/get-usx-labels';
import { useEnabledFeatures } from '../../common/hooks/enabled-features';
import { WorkspacePanelButton } from '../../panels/workspace-panel-button';
import { useDexNotification } from '../use-dex-notification';
import {
    useIsFederatedSearchEnabledButCheckingAvailability,
    useIsFederatedSearchEnabledButConfirmedUnavailable,
} from '../../federated-search/federated-search-remote-state-context';

export const DexResultsButton = observer(function DexResultsButton(): React.ReactElement | null {
    const { count = 0, isUrgent } = useDexNotification();
    const { dexNextEnabled } = useEnabledFeatures();
    const isFederatedSearchEnabledButConfirmedUnavailable = useIsFederatedSearchEnabledButConfirmedUnavailable();
    const isFederatedSearchEnabledButCheckingAvailability = useIsFederatedSearchEnabledButCheckingAvailability();

    if (isFederatedSearchEnabledButConfirmedUnavailable) {
        return null;
    }

    return (
        <HStack style={{ position: 'relative' }}>
            <WorkspacePanelButton
                tooltipText={`${getUniversalSearchLabel(dexNextEnabled)} Results`}
                workspacePanelType="DATA_EXCHANGE_RESULTS"
                aria-label="open dex results"
                icon="DataExchangeResults"
                isDisabled={isFederatedSearchEnabledButCheckingAvailability}
            />
            <NotificationCounter
                isUrgent={isUrgent}
                button="dex-results"
                style={{
                    position: 'absolute',
                    right: '0',
                    top: '0',
                    transform: 'translate(25%, 3%)',
                }}
            >
                {count}
            </NotificationCounter>
        </HStack>
    );
});
